export const ROLES = {
  ROLE_SUPER: "super",
  ROLE_ADMINISTRATOR: "administrator",
  ROLE_OWNER: "owner",
  ROLE_MANAGER: "manager",
  ROLE_USER: "user",
};
